module.exports = __webpack_public_path__ + "static/img/6en.4a7779f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/6en.png
// module id = U84e
// module chunks = 0